export default function LoadingSettings() {
  return (
    <main className='animate-pulse flex-1 max-w-screen-2xl mx-auto md:px-8 pt-10 pb-16 '>
      <div className='h-6 w-36 bg-neutralColor-light rounded-md border-b mb-5'></div>
      <div className='px-4 px-6 bg-neutralColor-light rounded-md shadow-md h-96'></div>
    </main>
  );
}
